import { call, put, takeEvery } from "redux-saga/effects"
import { MONITOR_ORDER_COUNT_LOAD,MONITOR_BILL_COUNT_LOAD} from "./actionTypes"
import { orderCountError, loadOrdersCount ,loadBillsCount} from "./actions"
import service from "../../../api/monitor.service"

function* loadMonitorOrdersCount(filter) {
  try {
    const response = yield call(service.getOrderCount, filter.payload)
    const error = response?.response?.data?.error
    if (error) {
      yield put(orderCountError(error))
    } else {
      yield put(loadOrdersCount(response?.data))
    }


  } catch (error) {
    yield put(orderCountError(error.message))
  }
}
 
function* loadMonitorBillsCount(filter) {
  try {
    const response = yield call(service.getBillCount, filter.payload)
    const error = response?.response?.data?.error
    if (error) {
      yield put(orderCountError(error))
    } else {
      yield put(loadBillsCount(response?.data))
    }


  } catch (error) {
    yield put(orderCountError(error.message))
  }
}


function* monitorOrderCountSaga() {
  yield takeEvery(MONITOR_ORDER_COUNT_LOAD, loadMonitorOrdersCount)
  yield takeEvery(MONITOR_BILL_COUNT_LOAD, loadMonitorBillsCount)
}

export default monitorOrderCountSaga
